import { cn } from "utils/cn";

interface IssuerLogoProps {
  src: string;
  name: string;
  className?: string;
}

export const IssuerLogo = ({ src, name, className }: IssuerLogoProps) => {
  if (!src) return null;
  return (
    <div
      className={cn(
        "flex items-center justify-center overflow-hidden bg-white-100",
        className
      )}
    >
      <img
        src={src}
        alt={`${name} logo`}
        className="object-contain max-h-full max-w-full"
      />
    </div>
  );
};
